module.exports = __webpack_public_path__ + "img/contact-details.f07f93a2.svg";